export default __webpack_public_path__ + "static/media/Imperial Acheronian Halberd.8a3b14e4.jpg";